import 'assets/css/app.scss';
const loadedComponents = [];

document.addEventListener('DOMContentLoaded', function() {
	document.dispatchEvent(new Event('lefLoadAllComponents'));
});

document.addEventListener( 'lefLoadAllComponents', async () => {
	// Javascript has been loaded, remove the no-js class and replace for js class.
	document.documentElement.classList.remove('no-js');
	document.documentElement.classList.add('js');

	/**
	 * Bootstrap the components
	 */
	for ( const dataComponent of document.querySelectorAll( '[data-component]' ) ) {
		let componentName = dataComponent.dataset.component;
		let componentFolder = dataComponent.dataset.folder;
		
		let componentFolderName = componentName;

		if (componentFolder != undefined && componentFolder != '') {
			componentFolderName = componentFolder + '/' + componentName;
		}

		if ( loadedComponents.indexOf( componentFolderName ) === - 1 ) {
			loadedComponents.push( componentFolderName );

			try {
				let component = await import(
					/* WebpackMode: "lazy" */
					/* webpackPrefetch: false */
					/* webpackPreload: false */
					`components/${componentFolderName}/${componentName}.js`
					);

				component.default();

				dataComponent.classList.add('component-loaded');
			} catch ( error ) {
				console.error( 'Loading error: ', error );
				dataComponent.classList.add('component-loaded'); // still add this for display
			}
		} else {
			dataComponent.classList.add('component-loaded');
		}
	}
} );

import 'assets/js/extra.js';
import 'assets/js/data-href.js';
import 'assets/js/animations.js';
import 'assets/js/readmore.js';
import 'assets/js/popups.js';
